module.exports = __webpack_public_path__ + "media/torsten3.66d14707.mp3";